<div [ngClass]="{ 'dark text-white-dark': store()?.semidark }">
    <nav
        class="sidebar fixed top-0 bottom-0 z-50 h-full min-h-screen w-[280px] shadow-[5px_0_25px_0_rgba(94,92,154,0.1)] transition-all duration-300">
        <div class="h-full bg-white dark:bg-[#0e1726]">
            <div class="flex items-center justify-between px-2 py-3">
                <a routerLink="/" class="main-logo flex shrink-0 items-center">
                    <img class="inline max-w-[200px] w-[min(200px,calc(100%-2.5rem))] ltr:-ml-1 rtl:-mr-1"
                        src="/assets/images/logo.svg" alt="" />
                </a>
                <a href="javascript:;"
                    class="collapse-icon flex h-8 w-8 items-center rounded-full transition duration-300 hover:bg-gray-500/10 hover:text-primary rtl:rotate-180 dark:text-white-light dark:hover:bg-dark-light/10"
                    (click)="storeData.dispatch({ type: 'toggleSidebar'})">
                    <icon-arrow-left class="size-5 m-auto rotate-180" />
                </a>
            </div>
            <ng-scrollbar class="relative !h-[calc(100vh-80px)]" appearance="compact">
                <ul class="relative space-y-0.5 pt-2 py-0 font-normal text-[16px]">
                    @if (slugs.DASHBOARD_VIEW | hasPermission) {
                    <li class="nav-item">
                        <a routerLink="/dashboard" class="group" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: false }" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-layout-grid class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Dashboard' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }
                    @if ((slugs.AGENT_LIST | hasPermission) || (slugs.AGENT_ARCHIVED_LIST | hasPermission)) {
                    <li class="nav-item">
                        <a routerLink="/manage-agent" class="group" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: false }" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-cpu-bolt class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Manage Agent' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }
                    @if (slugs.TENANT_LIST | hasPermission) {
                    <li class="nav-item">
                        <a routerLink="/manage-client" class="group" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: false }" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-contacts class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Manage Clients' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }
                    @if (slugs.USER_LIST | hasPermission) {
                    <li class="nav-item">
                        <a routerLink="/manage-admin-users" class="group" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: false }" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-users class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Manage Users' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }
                    @if (slugs.RULE_PACK_LIST | hasPermission) {
                    <li class="nav-item">
                        <a routerLink="/rule-packs" class="group" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: false }" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-star class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Rule packs' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }
                    @if (slugs.RULE_PACK_LIST | hasPermission) {
                    <li class="nav-item">
                        <a routerLink="/country-packs" class="group" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: false }" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-star class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Country packs' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }
                    @if (slugs.RULE_PACK_LIST | hasPermission) {
                    <li class="nav-item">
                        <a routerLink="/document-types" class="group" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: false }" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-star class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Document types' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }
                    @if (slugs.RULE_PACK_LIST | hasPermission) {
                    <li class="nav-item">
                        <a routerLink="/compliance-locks" class="group" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: false }" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-star class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Compliance locks' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }
                    @if (slugs.RULE_PACK_LIST | hasPermission) {
                    <li class="nav-item">
                        <a routerLink="/prompt-templates" class="group" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: false }" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-star class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Agent prompts' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }
                    @if (slugs.INTEGRATION_LIST | hasPermission) {
                    <li class="nav-item">
                        <a routerLink="/integrations" class="group" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: false }" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-components class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Integrations' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }
                    @if (slugs.BILLING_VIEW | hasPermission) {
                    <li class="nav-item">
                        <a routerLink="/invoices" class="group" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: false }" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-invoice class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Invoices' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }
                    @if ((slugs.SUBSCRIPTION_LIST | hasPermission)
                    || (slugs.SUBSCRIPTION_ARCHIVED_LIST | hasPermission)) {
                    <li class="nav-item">
                        <a routerLink="/subscriptions" class="group" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: false }" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-shopping-bag class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Subscriptions' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }
                    @if ((slugs.AUDIT_TRAIL_LIST | hasPermission) || (slugs.AUDIT_TRAIL_VIEW | hasPermission)) {
                    <li class="nav-item">
                        <a routerLink="/audit-trail" class="group" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: false }" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-forms class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Audit Logs' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }
                    @if ((slugs.AUDIT_TRAIL_LIST | hasPermission) || (slugs.AUDIT_TRAIL_VIEW | hasPermission)) {
                    <li class="nav-item">
                        <a routerLink="/audit-log" class="group" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: false }" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-forms class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Compliance Log' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }
                    @if (permissionService.canAny([slugs.REPORT_LIST, slugs.REPORT_VIEW])) {
                    <li class="nav-item">
                        <a routerLink="/reports" class="group" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: false }" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-charts class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Reports' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }                </ul>
            </ng-scrollbar>
        </div>
    </nav>
</div>